import CoverBoxes from "./CoverBoxes";

export default CoverBoxes;